import React, { Component } from "react";
import './Modal.css'
import Aux from "../../../HOC/Auxi";
import Backdrop from '../../../components/UI/Backdrop/Backdrop'



class Modal extends Component{
    state = {

    }
    render(){
        let classes=["Modal"]
        if(this.props.show){
            classes.push("Modal_Show")
        }else{
            classes.push("Modal_Hide")
        }

        return(
            <Aux>
                <Backdrop
                toggled={this.props.show}
                clicked={this.props.clicked}
                />
               
                <div className={classes.join(" ")}>
                    {this.props.children}
                </div>

            </Aux>
        )
    }
}

export default Modal